import { render } from "./SMSForm.vue?vue&type=template&id=1523cce1"
import script from "./SMSForm.vue?vue&type=script&lang=js"
export * from "./SMSForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__